export interface TipoPessoaModel {
  nome: string;
  descricao: string;
}

export const TipoPessoaFisica: TipoPessoaModel = {
  nome: "FISICA",
  descricao: "Pessoa física",
};
export const TipoPessoaJuridica: TipoPessoaModel = {
  nome: "JURIDICA",
  descricao: "Pessoa jurídica",
};

export const tiposPessoa: TipoPessoaModel[] = [
  TipoPessoaFisica,
  TipoPessoaJuridica,
];
